import * as React from 'react'
import { Block } from '$views/components'
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete'
import searchIcon from '$icons/search.svg'
import locationIcon from '$icons/location.svg'
import {
  StyledInput,
  StyledBlock,
  StyledItem,
  StyledInputBlock,
} from '$views/FullMapCaretakers/components/LocationSearchInput.style'
import { Icon } from '$views/components/Icon'
import { Text } from '$views/components'
import { PoweredByGoogle } from '$views/components/PoweredByGoogle/PoweredByGoogle'

interface Props {
  onPlaceChanged: (location: google.maps.GeocoderResult) => void
  address: string
  placeholder?: string
  icon?: boolean
}

export const LocationSearchInput: React.FC<Props> = ({ onPlaceChanged, address, icon, placeholder }) => {
  const [actualAddress, setAddress] = React.useState<string>('')

  const handleSelect = async selectedAddress => {
    const results = await geocodeByAddress(selectedAddress)
    results[0].formatted_address = selectedAddress
    onPlaceChanged(results[0])
    setAddress(selectedAddress)
    const activeElement: any = document.activeElement
    activeElement.blur()
  }

  React.useEffect(() => {
    if (address) {
      setAddress(address)
    }
  }, [address])

  const renderAutocompleteView = ({ getInputProps, suggestions, getSuggestionItemProps }) => {
    return (
      <StyledInputBlock>
        <StyledInput
          primary="true"
          {...getInputProps({
            placeholder: placeholder,
            className: 'location-search-input',
          })}
          icon={icon ? searchIcon : ''}
        />
        <StyledBlock>
          {suggestions.map(suggestion => {
            const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item'
            const style = suggestion.active
              ? { backgroundColor: '#f8f8f8', cursor: 'pointer' }
              : { backgroundColor: '#ffffff', cursor: 'pointer' }
            return (
              <StyledItem
                key={suggestion.placeId}
                {...getSuggestionItemProps(suggestion, {
                  className,
                  style,
                })}
              >
                <Icon content={locationIcon} size="s" color="grey" />
                <Text as="span">{suggestion.description}</Text>
              </StyledItem>
            )
          })}
          {suggestions.length > 0 && <PoweredByGoogle />}
        </StyledBlock>
      </StyledInputBlock>
    )
  }

  return (
    <Block>
      <PlacesAutocomplete
        value={actualAddress}
        onChange={setAddress}
        onSelect={handleSelect}
        highlightFirstSuggestion={true}
        shouldFetchSuggestions={actualAddress.length > 2}
        debounce={500}
        searchOptions={{ componentRestrictions: { country: 'es' } }}
      >
        {renderAutocompleteView}
      </PlacesAutocomplete>
    </Block>
  )
}



// WEBPACK FOOTER //
// ./src/views/FullMapCaretakers/components/LocationSearchInput.tsx